module.exports = __webpack_public_path__ + "static/media/CLARB.24eb6f16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/CLARB.png
// module id = 369
// module chunks = 0